import { UrlMatchType } from '@tob/shared/redirect-utils/constants';
import { isValidUrl } from '@tob/shared/redirect-utils/util';

export type ValidationConfig =
  | {
      matchType: UrlMatchType.ExactMatch;
      urlList: string[];
    }
  | {
      matchType: UrlMatchType.HostnameRegex;
      regexList: RegExp[];
    }
  | {
      matchType: UrlMatchType.HostnameAndPathnameRegex;
      regexList: Array<{ hostname: RegExp; pathname: RegExp }>;
    };

type SetCurrentUrlBaseParams = {
  url: string;
};

export function setCurrentUrl({
  url,
  isHardcodedUrl, // controls validation: true for trusted hardcoded URLs (skip), false for external (validate via validationConfig)
  validationConfig,
}:
  | (SetCurrentUrlBaseParams & {
      isHardcodedUrl: false;
      validationConfig?: ValidationConfig;
    })
  | (SetCurrentUrlBaseParams & {
      isHardcodedUrl: true;
      validationConfig?: undefined;
    })): string {
  if (!isHardcodedUrl) {
    if (
      validationConfig &&
      isValidUrl({
        url,
        authenticationConfig: validationConfig,
      })
    ) {
      window.location.href = url;
      return window.location.href;
    }
    throw new Error('URL validation failed');
  }
  window.location.href = url;
  return window.location.href;
}

export function replaceCurrentUrl({
  url,
  isHardcodedUrl, // controls validation: true for trusted hardcoded URLs (skip), false for external (validate via validationConfig)
  validationConfig,
}:
  | (SetCurrentUrlBaseParams & {
      isHardcodedUrl: false;
      validationConfig?: ValidationConfig;
    })
  | (SetCurrentUrlBaseParams & {
      isHardcodedUrl: true;
      validationConfig?: undefined;
    })): void {
  if (!isHardcodedUrl) {
    if (
      validationConfig &&
      isValidUrl({ url, authenticationConfig: validationConfig })
    ) {
      window.location.replace(url);
      return;
    }
    throw new Error('URL validation failed');
  }
  window.location.replace(url);
  return;
}
